if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name="id"]').disabled = false;
      this.submitButton = this.querySelector('[type="submit"]');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }
    async onSubmitHandler(event) {
      event.preventDefault();
      if (this.submitButton.disabled || this.submitButton.getAttribute('aria-disabled') === 'true') return;
      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', 'true');
      this.submitButton.classList.add('loading');
      const spinner = this.querySelector('.loading-overlay__spinner');
      spinner?.classList.remove('hidden');
      try {
        const response = await fetch(window.routes.cart_add_url + '.js', {method:'POST',headers:{Accept:'application/json'},body:new FormData(this.form)});
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || 'Unable to add this item. Please try again.');
        window.location.href = window.routes.cart_url;
      } catch (error) {
        this.handleErrorMessage(error.message);
      } finally {
        this.submitButton.removeAttribute('aria-disabled');
        this.submitButton.classList.remove('loading');
        spinner?.classList.add('hidden');
      }
    }
    handleErrorMessage(message = false) {
      const wrapper = this.querySelector('.product-form__error-message-wrapper');
      if (!wrapper) return;
      wrapper.hidden = !message;
      if (message) wrapper.querySelector('.product-form__error-message').textContent = message;
    }
  });
}